define([
	"dojo/_base/declare",
	"csi/state/rootStore",
	"Quality/NewFromTestRunTemplate"
], function(declare,{ routerStore },NewFromTestRunTemplate) {

	return declare(NewFromTestRunTemplate, {
		bSampleContext: true,

		/**
		 * @override
		 * Product is actually higher up because this is from Sample
		 */
		onCreatePopupParams: function(params) {
		    params = params || {};
		    params.testRunContextNode = routerStore.getBreadcrumbNode("Style") || routerStore.getBreadcrumbNode("Material");
		    params.testRunColor = this.getParent().ProductColor;
		    params.bCanCreateMultipleTestRuns = true;
		}
	});
});